module.exports = __webpack_public_path__ + "static/media/invites_paper.2f77664b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/invites_paper.svg
// module id = 2457
// module chunks = 71